/* AppInsights.ts */
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { getPortalSecretValue } from "../services/keyVaultService";

export const reactPlugin = new ReactPlugin();
export let appInsights: ApplicationInsights | null = null; // <-- export the instance

// Async initializer
export async function initAppInsights() {
  try {
    const secrets = await getPortalSecretValue();
 console.warn(secrets.PortalAppInsightConnStr);
    if (secrets.PortalAppInsightConnStr) {
      appInsights = new ApplicationInsights({
        config: {
          connectionString: secrets.PortalAppInsightConnStr,
          distributedTracingMode: 2,
          enableAutoRouteTracking: true,
          extensions: [reactPlugin],
        },
      });

      appInsights.loadAppInsights();
      appInsights.trackPageView();
      console.log("AppInsights initialized");
    } else {
      console.error(" AppInsights connection string not found in secrets.");
    }
  } catch (error) {
    console.error("Failed to initialize AppInsights:", error);
  }
}
